// extracted by mini-css-extract-plugin
module.exports = {"carousel":"w_z","large":"w_B"};